module.exports = __webpack_public_path__ + "static/media/logistics123.9a976f45.png";